import script from "./InputField.vue?vue&type=script&setup=true&lang=js"
export * from "./InputField.vue?vue&type=script&setup=true&lang=js"

import "./InputField.vue?vue&type=style&index=0&id=4e5aae84&lang=css"

const __exports__ = script;

export default __exports__